import { Link } from "gatsby";

const ButtonLink = ({ link, label }) => {
  return (
    <>
      {link &&
        label &&
        (link.href ? (
          <a
            className={`text-sm text-center md:text-base px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 inline-flex items-center bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
            href={link.href}
          >
            {label}
          </a>
        ) : link && link.reference && link.reference.path ? (
          <a
            href={link.reference.path}
            className={`text-sm text-center md:text-base px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 inline-flex items-center bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
          >
            {label}
          </a>
        ) : (
          "Reference page is missing its path"
        ))}
    </>
  );
};

export default ButtonLink;
